import template from "./index.html";
import "./index.less";
import { globs } from "../../services/globs";
import supportCenterContentModule from "../support-center-content/support-center-content";

export function controller(
	appState,
	config,
	$uibModal,
	hotkeys,
	$userProfile
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl._uibModal = $uibModal;
	ctrl.onPrivacyClick = onPrivacyClick;
	ctrl.onSupportAndFeedbackClick = onSupportAndFeedbackClick;
	ctrl.onTermsClick = onTermsClick;
	ctrl.hotkeys = hotkeys;
	ctrl.userProfile = $userProfile.getUserProfile();

	ctrl.canViewVeslFeedback = globs.feedback.vesl.read;
	ctrl.canViewAgencyFeedback = globs.feedback.agency.read;
	ctrl.canViewAgencyPhoneNumber = globs.feedback.agency.phoneNumber.read;
	ctrl.canViewAgencyEmail = globs.feedback.agency.email.read;
	ctrl.canViewAgencyMarkdown = globs.feedback.agency.markdown.read;

	function onInit() {
		ctrl.form = appState.forms.selected;
		ctrl.support = config.support;

		ctrl.supportMarkdown = ctrl.form?.nomenclature?.SupportMarkdown || "";
	}

	function onPrivacyClick() {
		$uibModal.open({
			component: "privacy-policy",
			size: "lg"
		});
	}

	function onSupportAndFeedbackClick() {
		$uibModal.open({
			component: "support-feedback"
		});
	}
	function onTermsClick() {
		$uibModal.open({
			component: "terms",
			size: "lg"
		});
	}
}

export default angular
	.module("vesl.components.support-info", [supportCenterContentModule])
	.component("supportInfo", {
		template,
		controller
	}).name;
